import { useAuth0 } from '@auth0/auth0-react';
import icon from 'assets/img/icons/empty-card-packs.svg'

const BuyPacksEmpty = () => {

  const {loginWithRedirect} = useAuth0();

  return (
    <div className="empty-packs">
      <img src={icon} className="empty-packs__pic" alt="" />
      <h2 className="empty-packs__title">Please login to see Card Packs </h2>
      <button onClick={loginWithRedirect} className='empty-packs__link'>Log in</button>
    </div>
  )
}

export default BuyPacksEmpty;
